import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import CheckboxField from '../../../FormLegacy/FormFieldsV2/CheckboxField'
import SelectField from '../../../FormLegacy/FormFieldsV2/SelectField'
import Tooltip from '../Tooltip/Tooltip'
import { getSocialLinkServiceOptions } from '../../../Organisation/CommunicationPortal/helpers'

const PositiveReviewFollowup = ({
  handleCheckboxChange,
  handleFieldChange,
  formState,
  options,
  tooltips,
}) => {
  const { t } = useTranslation(['create-event'])
  const availableServices = options.map((opt) => opt.service)
  const availableOptions = getSocialLinkServiceOptions(t)
    .filter((opt) => availableServices.includes(opt.value))
    .map((opt) => ({ ...opt, id: opt.value }))
  return (
    <div className="extra-field">
      <div className="input-row">
        <div className="input-container inline">
          <CheckboxField
            name="positiveReviewFollowup"
            onChange={handleCheckboxChange}
            value={formState.positiveReviewFollowup}
          />
          <div className="input-label">
            {t('create-event:positiveReviewFollowup.positiveReviewFollowup')}{' '}
            <Tooltip name="positive-review-followup" tooltips={tooltips} />
          </div>
        </div>
      </div>
      <div className="description">{t('create-event:positiveReviewFollowup.description')}</div>
      {formState.positiveReviewFollowup && (
        <React.Fragment>
          <div
            className="input-row"
            style={{ marginLeft: '40px', flexDirection: 'column', alignItems: 'flex-start' }}
          >
            {!availableServices.length ? (
              <div>{t('create-event:positiveReviewFollowup.noSocialLinkServicesAvailable')}</div>
            ) : (
              <div className="input-container" style={{ width: '100%' }}>
                <div className="input-label">
                  {t('create-event:positiveReviewFollowup.selectSocialLink')}
                </div>
                <SelectField
                  options={availableOptions}
                  name="socialLinkService"
                  onChange={handleFieldChange}
                  value={formState.socialLinkService}
                  selectStyle={{ width: '100%' }}
                />
              </div>
            )}
            <a href="/#/dashboard/building-dashboard/social-links" target="__blank">
              {t('create-event:positiveReviewFollowup.createSocialLink')}
            </a>
          </div>
        </React.Fragment>
      )}
    </div>
  )
}

PositiveReviewFollowup.propTypes = {
  handleCheckboxChange: PropTypes.func,
  handleFieldChange: PropTypes.func,
  formState: PropTypes.object,
  options: PropTypes.array,
  tooltips: PropTypes.array,
}

export default PositiveReviewFollowup
